import { useCallback } from 'react';
import * as snsJoinActions from 'app/store/modules/join/sns';
import { useDispatch, useSelector } from 'react-redux';
import { getJoinData } from 'app/libs/joinStorageUtils';

export default function useDuplicateSns() {
	const joinData = getJoinData();
	const dispatch = useDispatch();
	const { isInit, hasBeforeSocialAgreement, duplicateList } = useSelector((state) => state.join.sns);

	const socialData = joinData?.social;

	const getSnsDuplicateList = useCallback(
		async (duplicateCheckUserName, phone) => {
			if (!socialData) return false;
			try {
				return await dispatch(snsJoinActions.getDuplicateJoinData(duplicateCheckUserName, phone, socialData.platform, socialData.token));
			} catch (e) {
				if (e.response && e.response.status === 404) {
					console.log('기존 가입 이력 없음.');
				} else {
					console.error('오류 발생:', e);
				}
			}
			return false;
		},
		[dispatch, socialData],
	);

	return {
		isInit,
		hasBeforeSocialAgreement,
		duplicateList,
		getSnsDuplicateList,
	};
}
